module.exports = __webpack_public_path__ + "static/img/2017-12-06.fbe30ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/press/2017-12-06.png
// module id = aequ
// module chunks = 1